<div class="h-[48px] flex items-center overflow-hidden cursor-pointer" routerLink="/">
  <div
    [class.h-24]="size() === 'lg'"
    [class.w-24]="size() === 'lg'"
    [class.text-lg]="size() === 'lg'"
    [class.h-20]="size() === 'sm'"
    [class.w-20]="size() === 'sm'"
    [class.text-md]="size() === 'sm'"
    class="flex justify-center bg-accent rounded-full pl-1 pr-1 font-semibold font-raleway leading-none"
  >
    <div class="w-fit flex flex-col justify-center -mt-1 pt-[3px] font-medium">
      <span class="text-black mb-0.5">Box</span>
      <span class="text-white">Delivery.</span>
    </div>
  </div>
</div>
